import React, { useState } from 'react';
import './App.css';
import './styles/normalize.custom.css';
import './styles/styles.css';
import UiContents from './components/UiContents';
import JsonContents from './components/JsonContents';
import ErrorBoundary from './ErrorBoundary';
import kakaoBtn from './assets/images/kakaochatead@x4.png';

const defaultValue = {
    version: '2.0',
    template: {
        outputs: [
            {
                simpleText: {
                    text: '꿈청 챗봇 JSON 생성기',
                },
            },
        ],
    },
};

function App() {
    const [obj, setObj] = useState(defaultValue);
    // 콜백
    const parentCallback = (dataFromChild) => {
        // 자식 컴포넌트에서 받은 값을 이용한 로직 처리
        setObj(dataFromChild);
    };

    return (
        <>
            <ErrorBoundary>
                <div className="App">
                    <UiContents obj={obj} callbackFromParent={parentCallback} />
                    <JsonContents
                        obj={obj}
                        callbackFromParent={parentCallback}
                    />
                    {/* <a
                        href="http://pf.kakao.com/_Wxexfxnxb"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="kakao-link"
                    >
                        <img src={kakaoBtn} alt="카카오톡 챗봇 미리보기" />
                    </a> */}
                </div>
            </ErrorBoundary>
        </>
    );
}

export default App;
